export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/3f9d08657732a00d46764fd5d7882698.png";